import React from 'react';
import { Trans } from '@lingui/macro';
import { Icon } from '@economic/taco';

const ServiceCostLine = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="flex gap-2">
            <Icon name="tick" />
            {children}
        </div>
    );
};

const PaymentCardsOnboardingDialogServiceCostStep2 = () => {
    return (
        <div className="flex flex-col gap-2 h-[477px]">
            <h2>
                <Trans>What does it cost?</Trans>
            </h2>
            <Trans>
                When you order a company card for your business the first one is free of charge. If you need more cards you can
                always order them through your subscription in e-conomic. Company cards are available in all packages in
                e-conomic.
            </Trans>
            <div className="flex flex-col p-4 gap-4 mt-4">
                <div>
                    <h4>
                        <Trans>Cost of additional cards</Trans>
                    </h4>
                    <ServiceCostLine>
                        <Trans>Placeholder</Trans>
                    </ServiceCostLine>
                </div>
                <div>
                    <h4>
                        <Trans>Apply for credit</Trans>
                    </h4>
                    <div>
                        <Trans>
                            You can apply for credit in the onboarding process or at a later stage after you have received your
                            company card.
                        </Trans>
                    </div>
                </div>
                <div>
                    <ServiceCostLine>
                        <Trans>Get credit up to DKK 100.000</Trans>
                    </ServiceCostLine>
                    <ServiceCostLine>
                        <Trans>Pay back monthly via invoice or pay in installments</Trans>
                    </ServiceCostLine>
                </div>
                <div>
                    <h4>
                        <Trans>Cost of credit</Trans>
                    </h4>
                    <div>
                        Read more about pricing at{' '}
                        <a href="https://www.mynt.com/en/company-card/pricing" target="_blank" rel="noopener noreferrer">
                            Mynt’s pricing page
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentCardsOnboardingDialogServiceCostStep2;
